jQuery(function($) {

    $('[data-move]').each(function () {
        $($(this).data('move')).append(this);
    });

	function initMainAutocomplete() {
		var $element = $('[data-autocomplete]');

		if (!$element.length || $element.data('acReady')) {
			return;
		}

		$element.data('acReady', true);

		var $form = $element.closest('form');
		var list = [];
		var url = $form.attr('data-suggest-url');

		var instance = $element.autocomplete({
			source: function (request, response) {

				var data = $form.serializeArray();
				var params = [];

				$.each(data, function () {
					if (this.name == 'tx_offers_search[filter][list]') {
						this.value = '';
					}
					if (this.name !== 'tx_offers_search[action]') {
						params.push(this);
					}
				});

				$.ajax(url,{
					method: 'POST',
					data: params
				})
					.fail(function (error) {
						console.log(error);
					})
					.done(function (data) {
						list = data.lists;
						response(data.suggestions);
					});
			},
			select: function(event, ui) {
				this.value = ui.item.value;
				$form.find('[data-list-id]').val('');
				jQuery(event.target).closest('form').submit();
			}
		}).autocomplete('instance');

		var menu = instance.menu;

		// Disable Extra Menu
		menu.options.items = "> li:not(.autocomplete-direct-links)";

		instance._renderMenu = function( ul, items ) {
			var that = this;

			$(ul).addClass('autocomplete-styled');

			$.each( items, function( index, item ) {
				that._renderItemData( ul, item );
			});

			if (list.length) {
				var $extra = $('<li class="autocomplete-direct-links"><div class="autocomplete-direct-links-title">Suchen nach "' + $element.val().replace(/(<([^>]+)>)/ig,"") + '" in:</div></li>');

				$.each(list, function (index, item) {
					var $link = $('<a class="autocomplete-direct-links-link" href="' +  item.value +'">' + item.name + '<span class="count">(' + item.count + ')</span></a>');
					var $wrap = $('<div></div>').append($link);

					$extra.append($wrap);
				});

				$( ul ).append($extra);
			}
		};

		// Remove focus on move over link
		menu.element.on('mouseenter', '.autocomplete-direct-links-link', function () {
			menu.blur();
		});

		// Submit form with additional parameter
		menu.element.on('click', '.autocomplete-direct-links-link', function (event) {
			event.preventDefault();

			var list = $(this).attr('href');

			var $form = $element.closest('form');
			$form.find('[data-list-id]').val(list);
			$form.submit();

			return false;
		});
	}

	function initSearchForm() {
		var searchForm = $('form.search-form[data-suggest]');
		if (searchForm.length > 0) {
			var suggestUrl = searchForm.data('suggest');
			if (suggestUrl != null && suggestUrl.length > 0) {
				var searchFormCheckboxes = searchForm.find('.filter input:checkbox[data-search-suggest-channel="1"]');
				if (searchFormCheckboxes.length > 0) {
					searchForm.data('originalSuggest', suggestUrl);
					setSearchSuggestFilters(searchFormCheckboxes.first());
					$('.search-form .filter input:checkbox[data-search-suggest-channel="1"]').on('change', function () {
						setSearchSuggestFilters(this);
					});
				}
			}
		}
	}

	/**
	 * close possible open search or contact boxes on top of the page
	 */
	$('#header .wx-header-menu .link.wx-zone[data-wx-toggle]').on('click', function(e){
		var _linkToHide = $('#header .wx-header-menu .link[data-wx-toggle].open').not('#'+ $(this).attr('id')),
			_elemToHide = $(_linkToHide.attr('data-wx-toggle'));

		if (_linkToHide.length > 0) {
			e.preventDefault();
			_linkToHide.removeClass('open');
			_elemToHide.css('display', 'none');
		}
	});

	function initSearchCalendar() {
		$('div[data-calendar]').each(function(){
			var _inputs = $(this).find('[data-calendar]'),
				_start = $(this).data('min'),
				_end = $(this).data('max'),
				_startInput = $(this).find('[data-calendar="start"]'),
				_endInput = $(this).find('[data-calendar="end"]'),
				_valueHolder = $(this).find('input[type="text"]'),
				_options = {
					"locale": {
						"format": "DD.MM.YYYY",
						"separator": " - ",
						"applyLabel": "Anwenden",
						"cancelLabel": "Abbrechen",
						"fromLabel": "von",
						"toLabel": "bis",
						"customRangeLabel": "Eigene",
						"weekLabel": "W",
						"daysOfWeek": [
							"So",
							"Mo",
							"Di",
							"Mi",
							"Do",
							"Fr",
							"Sa"
						],
						"monthNames": [
							"Jänner",
							"Februar",
							"März",
							"April",
							"Mai",
							"Juni",
							"Juli",
							"August",
							"September",
							"Oktober",
							"November",
							"Dezember"
						],
						"firstDay": 1
					},
					opens: 'left',
					autoUpdateInput: false,
					autoApply: true,
					minDate: _start,
					maxDate: _end,
				},
				_value = '';

			if (_startInput.val() !== '') {
				_options['startDate'] = _startInput.val();
				_value += _startInput.val();
			}

			if (_endInput.val() !== '') {
				_options['endDate'] = _endInput.val();
				_value += ' - '+ _endInput.val();
			}

			if (_value !== '') {
				_valueHolder.val(_value);
			}

			_valueHolder.daterangepicker(_options, function(start, end, label) {
				if (_startInput.val() === start.format('DD.MM.YYYY') && _endInput.val() === end.format('DD.MM.YYYY')) {
					return void(0);
				}

				_startInput.val(start.format('DD.MM.YYYY'));
				_endInput.val(end.format('DD.MM.YYYY'));
				_valueHolder.val(start.format('DD.MM.YYYY') +' - '+ end.format('DD.MM.YYYY'));
				_inputs.closest('form').submit();
			});
		});
	}

	function initSearchComponents() {
		initSearchCalendar();
		initMainAutocomplete();
		initSearchForm();
	}

	$(function () {
		initSearchComponents();
	});

	function loadSearchResult(_eventsSelector, method, url, data, _filterSelector, _paginationSelector, disablePushState, fullReplace) {
		var _loading = $('<div />').addClass('loading');

        if (fullReplace) {
            $(fullReplace).prepend(_loading);
        } else {
            $(_eventsSelector).prepend(_loading);
        }

		$[method](url, data, function (response) {
            _loading.remove();

			var _persistentUrl = $(response).find('[data-persistent-url]').data('persistentUrl'),
				_filter = $(response).find(_filterSelector).children(),
				_events = $(response).find(_eventsSelector).children(),
				_pagination = $(response).find(_paginationSelector).children(),
				_eventsCount = parseInt(_events.find('.events-count span:first-child, .offers-count span:first-child').text()),
				_fixedFooterSelector = '.fixed-footer-filter',
				_fixedFooter = $(response).find(_fixedFooterSelector).children();

            if (fullReplace) {
                $(fullReplace).replaceWith($(response).find(fullReplace));
                initSearchCalendar();
            } else {
                if (_events.length > 0) {
                    $(_eventsSelector).html(_events);
                }

                if (_filter.length > 0) {
                    $(_filterSelector).html(_filter)

                    if (typeof(Storage) !== "undefined") {
                        var _sidebarStates = localStorage.getItem('sidebarStates');

                        if (_sidebarStates) {
                            _sidebarState = JSON.parse(_sidebarStates);
                        } else {
                            _sidebarState = [];
                        }

                        $.each(_sidebarState, function(k,v) {
                            var _elem = $('[data-target="'+ k +'"]');

                            if (v === 'false') {
                                _elem.attr('aria-expanded', 'false');
                                $(k).removeClass('in');
                            }
                        });
                    }
                }

                if (_fixedFooter.length > 0) {
                    $(_fixedFooterSelector).html(_fixedFooter);
                }

                if (_paginationSelector) {
                    $(_paginationSelector).html(_pagination);
                }

                if (_eventsCount > 0 && $('.filter.fixed').length > 0) {
                    $('.fixed-footer-filter .button').prepend(
                        $('<span class="show-count" />').text(_eventsCount + ' Anzeigen')
                    ).addClass('close-filter');
                    $('.fixed-footer-filter button').text(_eventsCount + ' Anzeigen').addClass('close-filter');
                }

                initSearchCalendar();
            }

			if (_persistentUrl && !disablePushState) {
				history.pushState({
					events: _eventsSelector,
					method: method,
					xhrUrl: url,
					filter: _filterSelector,
					pagination: _paginationSelector,
                    full: fullReplace
				}, document.title, _persistentUrl);
			}

			// reset datalayer
			if (typeof window.google_tag_manager !== 'undefined') {
				window.google_tag_manager['GTM-WLS3DKD'].dataLayer.reset();
			}

			if (window.dataLayer) {
                var params = {}, query = [], items = {}, facet = [], _zone = '', _section = '';

                $("#events form.xhr-form, #offers form.xhr-form").serializeArray().forEach(function (el) {
                    if (el.value && /filter/.test(el.name)) {
						var elements = el.name.replace(/\[/g,',').replace(/\]/g,',').replace(/\,,/g,',');

                        elements = elements.substr(0, elements.length - 1).split(',');

						if (el.name.indexOf('tx_offers_search') !== -1) {
							_section = 'offers';
						} else {
							_section = 'events';
						}

						if (elements.length === 4) {
							if (!facet[elements[2]]) {
								facet[elements[2]] = [];
							}

							facet[elements[2]].push($('[name="'+ el.name +'"]').parent().find('a span').text());
						} else {
							if (el.name.indexOf('tx_offers_search') !== -1) {
								Object.assign(items, {[el.name.substr('tx_offers_search[filter]['.length).substr(0, el.name.substr('tx_offers_search[filter]['.length).length -1)]: el.value});
							} else {
								Object.assign(items, {[el.name.substr('events[filter]['.length).substr(0, el.name.substr('events[filter]['.length).length -1)]: el.value});
							}
						}

                        params[el.name] = el.value;
                        query.push(el.name + "=" + el.value);
                    }
                });

				if (facet) {
					Object.assign(items, facet);
				}

				if (localStorage.getItem('tomorrowButton')) {
					Object.assign(items, {['tomorrowButton']: 1});
					localStorage.removeItem('tomorrowButton');
				}

				if (localStorage.getItem('todayButton')) {
					Object.assign(items, {['todayButton']: 1});
					localStorage.removeItem('todayButton');
				}

				$($('body').attr('class').split(' ')).each(function(k, v){
					if (v.indexOf('wx-zone-') !== -1) {
						_zone = v.substr('wx-zone-'. length);
					}
				});

                var event = {
                    'event': 'ajaxComplete',
					'section': _section,
					'zone': _zone,
					'page': $('.breadcrumbs li:last-child').text(),
                    'attributes': {
                        'url': url,
                        'queryParameters': params,
                        'queryString': query.join('&'),
						'elements': items
                    }
                };

                window.dataLayer.push(event);
            }


		}).fail(function (data) {
			$(_eventsSelector).find('.row').replaceWith('<div class="row"><div class="col-xs-12 events-error">' + data.responseText + '</div></div>');
			$('div.loading').remove();
			return void (0);
		});
	}

    var xhrDefaultUrl = $("[data-xhr-default]").data('xhrDefault');

	window.onpopstate = function(event) {
		var s = event.state,
			isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

		if (isSafari === false) {
            if (!s) {
                if (!xhrDefaultUrl) {
                    console.log("Received pop state %o, but without state information", event);
                    return;
                }

                s = {
                    events: "",
                    method: "get",
                    xhrUrl: xhrDefaultUrl,
                    data: null,
                    filter: "",
                    pagination: "",
                    full: "#events"
                };
            }

            console.log("Pop load for %o", s);
			loadSearchResult(s.events, s.method, s.xhrUrl, s.data, s.filter, s.pagination, true, s.full || null);
			console.log("loadSearchResults");
		} else {
			console.log("prevent loadSearchResults - safari");
		}
	};

	function xhrSearch(e) {
		var el = $(e.target).closest('[data-xhr-url]'),
			data = el.prop('tagName').toLowerCase() === 'form' ? el.serialize() : '',
			method = (el.attr("method")+"").toLowerCase() === 'post' ? 'post' : 'get',
			sel = '[data-container=' + el.data('xhrTarget') + ']',
			container = el.closest(sel),
			url = el.data('xhrUrl'),
			_filterSelector = 'form.xhr-form aside .filter',
			_eventsSelector = 'div.events.xhr-replace, div.offers.xhr-replace',
			_paginationSelector = '.paging.events.listing, .pagination';

		if (!container.length) {
			return;
		}

		loadSearchResult(_eventsSelector, method, url, data, _filterSelector, _paginationSelector, false);
		e.preventDefault();
	}

	$(document).on('change', 'select.has-xhr-options', function(e){
		var _url = $(this).find('option:selected').attr('data-xhr-url'),
			_filterSelector = 'form.xhr-form aside .filter',
			_eventsSelector = 'div.events.xhr-replace, div.offers.xhr-replace',
			_paginationSelector = '.paging.events.listing, .pagination';

		loadSearchResult(_eventsSelector, 'get', _url, '', _filterSelector, _paginationSelector, false);
		e.preventDefault();
	});

	$(document).on('click', 'li.load-more > a', function(e){
		e.preventDefault();

		var _paginationSelector = '.paging.events.listing, .pagination',
			_xhrUrl = $(_paginationSelector).find('.right > .switch, .next > a').data('xhrUrl'),
			_eventsSelector = '.events-list, .offers-list, ul.items.recommendations',
			_loading = $('<div />').addClass('loading');

		$(this).parent().remove();
		$(_eventsSelector).prepend(_loading);
		$('.fade-out').removeClass('fade-out');
		$('.fade-in').removeClass('fade-in');

		$.get(_xhrUrl, function(data){
			var _events = $(data).find(_eventsSelector).children(),
				_pagination = $(data).find(_paginationSelector).children();

			$(_eventsSelector).append($(_events).addClass('fade-out'));

			if ($(_pagination).find('.right > .switch').length <= 0 && $(_pagination).parent().find('.next > a').length <= 0) {
				$(_eventsSelector).find('li.load-more').remove();
			}

			$(_paginationSelector).html(_pagination);
		}).always(function() {
			$('div.loading').remove();

			setTimeout(function(){
				$('.fade-out').addClass('fade-in');
			}, 500)
		});
	});

	$('.tx-events-listview,.tx-offers-searchwrapper')
		.on('click', 'a[data-xhr-url]', xhrSearch)
		.on('submit', 'form[data-xhr-url]', xhrSearch)
		.on('click', '[data-event=click]', function (e) {
			if ($(this).data('trigger') === 'form') {
				$(this).closest('form').trigger('submit');
				e.preventDefault();
			}
		})
		.on('change', '[data-event=change]', function (e) {
			if ($(this).data('trigger') === 'form') {
				$(this).closest('form').trigger('submit');
				e.preventDefault();
			}
		});

    $(document).on("click", "[data-container=xhr-navigation] a[data-xhr-url]", function (event) {
        var el = $(event.target).closest("[data-xhr-url]")[0],
            target = document.querySelector(el.dataset.xhrTarget),
            url = el.dataset.xhrUrl;

        if (el && url) {
            loadSearchResult(
                "[data-container=xhr-navigation] .events.xhr-replace",
                'get',
                url,
                '',
                '[data-container=xhr-navigation] .filter-xhr-replace',
                "[data-container=xhr-navigation] .xhr-replace-pagination",
                false,
                el.dataset.xhrFull && target ? el.dataset.xhrTarget : null
            );

            event.preventDefault();
        }
    });

	function setSearchSuggestFilters(element) {
        var filterContainer = $(element).closest('.filter');
        if (filterContainer.length > 0) {
            var searchForm = filterContainer.closest('form.search-form[data-suggest]');
            if (searchForm.length > 0) {
                var suggestUrl = searchForm.data('originalSuggest');
                if (suggestUrl != null && suggestUrl.length > 0) {
                    var urlPrefix = filterContainer.data('urlPrefix');
                    var filters = filterContainer.find('input:checkbox[data-search-suggest-channel="1"]:checked');
                    filters.each(function() {
                        suggestUrl += '&' + urlPrefix + '[channels][]=' + encodeURIComponent($(this).val());
                    });
                    searchForm.data('suggest', suggestUrl);
                    searchForm.attr('data-suggest', suggestUrl);
				}
            }
		}
	}
});

(function ($) {

	function bindTriggerClick() {
		$('[data-wx-trigger]').on('click', function (event) {
			event.preventDefault();

			var targets = $(this).attr('data-wx-trigger').split(',');
			$.each(targets, function(index, element) {
				$(element).trigger('click');
			});

			return false;
		});
	}


	function bindToggleContactMenu() {
		$('[data-wx-toggle]').on('click', function (event) {
			event.preventDefault();

			// set position of meta navigation for toggle position
			var _navPosLeft = $('.wx-header-menu.right').offset().left,
				_socialNavPosLeft = $('.social-media-links--desktop').offset().left,
				_socialNavPosTop = $('.social-media-links--desktop').offset().top;

			document.documentElement.style.setProperty('--nav-position', _navPosLeft +'px');
			document.getElementsByClassName('social-media-links--desktop')[0].style.setProperty('--nav-position', _socialNavPosLeft +'px');
			document.getElementsByClassName('social-media-links--desktop')[0].style.setProperty('--nav-position-top', _socialNavPosTop +'px');

			var that = $(this);
			that.toggleClass('open');

			var focusOnOpen = that.attr('data-wx-toggle-focus-open') || false;
			var focusOnClose = that.attr('data-wx-toggle-focus-close')  || false;
			var animations = (that.attr('data-wx-animation') || '').split(',');
			var targets = (that.attr('data-wx-toggle') || '').split(',');

			if (that.attr('data-wx-close')) {
				var close = that.attr('data-wx-close').split(',');

				$('body, html').animate({
					scrollTop: 0
				}, 400, function () {
					if (!that.hasClass('open')) {
						$('#header').removeClass('open');
					}
				});

				$.each(close, function (index, target) {
					var link = $(target);
					if (that.hasClass('open') && link.hasClass('open')) {
						link.trigger('click');
					}
				});
			}

			$.each(targets, function (index, target) {
				var animation = animations[index] || animations[animations.length - 1] || 'toggle';
				$(target)[animation.trim()]();
			});

			setTimeout(function () {
				if (that.hasClass('open')) {
					focusOnOpen && $(focusOnOpen).focus();
					$('#header').addClass('open');
				} else {
					focusOnClose && $(focusOnClose).focus();
				}
			}, 1);

			return false;
		});
	}

	function bindScrollToAnchor() {
		$('[data-scroll="animated"]').click(function(event){
			event.preventDefault();

			var that = $(this)
				, target = that.attr('href');

			$('html, body').animate({
				scrollTop: $(target.substr(target.indexOf('#'))).offset().top
			}, 1000);

			return false;
		});
	}

	function bindScrollTopButton() {
		var scrollButton = $('#scroll');

		var initialHeight = $(window).scrollTop();
		if (initialHeight == 0) {
			scrollButton.hide();
		}

		scrollButton.on('click', function(event) {

			$('body,html').animate({ scrollTop : 0 }, 1000);

			event.preventDefault();
			return false;
		});

		$(window).on('scroll', function () {
			var height = $(window).scrollTop();
			if (height > 0) {
				scrollButton.fadeIn();
			} else {
				scrollButton.fadeOut();
			}
		});
	}

	function bindSmoothScrolling() {
        $('.scroll-to-id a').on('click', function(event) {

            $('body,html').animate({ scrollTop : $(event.currentTarget.hash).offset().top }, 1000);

            event.preventDefault();
            return false;
        });
	}

	function bindSearchDismissButton() {
		$('#dismiss-search').on('click', function() {
			$('#show-search').removeClass('open');
		});
	}

	function bindResponsiveMenuToggle() {
		$('.wx-menu-toggle').on('click', function () {

			$(this).siblings('ul').slideToggle(function () {
				$(this).find('li.open > .wx-menu-toggle').trigger('click');
			}).parent('li').toggleClass('open');
		});
	}

	// open first available event date - if no date is available, open the first event date
	function bindAvailableEventDateToggle() {
		var collapse = $('#accordion-events').find('.data-date-available:first').find('.collapse:first');

        if (collapse.length == 0) {
        	collapse = $('#accordion-events').find('.collapse:first');
		}

		if (collapse) {
            collapse.collapse('show');
		}
	}

	function bindEventToggle() {
		$('[data-event-toggle]').on('click', function(){
			var target = $(this).attr('data-event-toggle');
			$('.panel-toggle', target).toggleClass('panel-hidden');
		});
	}

	function bindFocus() {
		$('[data-event-focus]').on('click', function(){
			var target = $(this).attr('data-event-focus');
			setTimeout(function() {
				$(target).focus();
			}, 1);
		});
	}

	function bindTitleToggle() {
		$('[data-title-toggle]').on('click', function(){
			var that = $(this)
				, text = that.attr('data-title-toggle');
			that.attr('data-title-toggle', that.text()).text(text);
		});
	}

	function initializeDatePicker() {
		$('.form-group.date input').datepicker({
			format: "dd.mm.yyyy",
			todayBtn: "linked",
			language: "de",
			orientation: "top auto",
			disableTouchKeyboard: false,
			autoclose: true
		});

		$('.input-group-addon').on('click', function() {
			var that = this;
			setTimeout(function() {
				$(that).prev('input').focus();
			}, 1);
		});
	}

	function initializeFancyBox() {
		$(".fancybox").fancybox({
			autoDimensions: false,
			beforeLoad: function() {
				this.title = $(this.element).attr('data-caption') || $(this.element).parent('figure').find('figcaption').text() || $(this.element).attr('title');
			}
		});
	}

	function initializeCollapseScroll() {
		$('.panel').on('shown.bs.collapse', function (event) {
			event.stopPropagation();

			var that = $(this)
				, scrollTop = $(window).scrollTop()
				, top = that.offset().top;

			if ((top - scrollTop) < 0) {
				$('html, body').stop().animate({
					scrollTop: top + 1
				}, '250');
			}

		});
	}

	function initializeEventBookingForm() {
	    if (!document.getElementById('firstEventBooking') || !document.getElementById('participantEmail')) {
	        return;
        }

	    function isText(selector) {
	        var val = (document.getElementById(selector).value + "").replace(/\s+/g, '');
	        return val.length > 0;
        }

	    function req(selector, required) {
            document.getElementById(selector).required = required;
        }

	    function isValid() {
	        try {
	            var valid = true,
                    needsParticipant = $(".time-to-act-events [data-participant=1] input:checked").length > 0 || $("[data-participant=1].list-view.booked").length > 0,
                    needsCompanion = $(".time-to-act-events [data-companion=1] input:checked").length > 0 || $("[data-companion=1].list-view.booked").length > 0;

	            if (!document.getElementById("acceptedPolicy").checked) {
	                valid = false;
                }

	            if (needsParticipant && (!isText("participantEmail") && !isText("participantPhone"))) {
                    req("participantEmail", true);
                    req("participantPhone", true);
                    valid = false;
                } else {
                    req("participantEmail", false);
                    req("participantPhone", false);
                }

	            if (document.getElementById("companionFirstname")) {
                    req("companionFirstname", needsCompanion);
                    req("companionLastname", needsCompanion);

	                if (needsCompanion && (!isText("companionFirstname") || !isText("companionLastname"))) {
                        valid = false;
                    }

                    if (needsCompanion && (!isText("companionEmail") && !isText("companionPhone"))) {
                        req("companionEmail", true);
                        req("companionPhone", true);
                        valid = false;
                    } else {
                        req("companionEmail", false);
                        req("companionPhone", false);
                    }
                }

	            return valid;
            } catch (e) {
                req("companionEmail", false);
                req("companionPhone", false);
                req("participantEmail", false);
                req("participantPhone", false);
	            console.error(e);
	            return false;
            }
        }

	    $(document).on("change click blur focus", "#participantEmail, #participantPhone, #companionFirstname, #companionLastname, #companionEmail, #companionPhone, #acceptedPolicy, #submitBooking", function (e) {
	        isValid();
        });

        isValid();
    }

    function initializeImageCompareViewer() {
        var imageCompareContainerElements = Array.from(document.querySelectorAll('.compare-slider__images'));
        imageCompareContainerElements.forEach(function initializeImageCompareView(element) {
            var imageCompare = new ImageCompare(element, {
                smoothing: false,
                startingPoint: 75,
                showLabels: false,
                labelOptions: {
                    before: element.dataset.titleLeft,
                    after: element.dataset.titleRight
                }
            });
            imageCompare.mount();
        });
    }

	$(function () {
		bindToggleContactMenu();
		bindScrollTopButton();
		bindSmoothScrolling();
		bindScrollToAnchor();
		bindSearchDismissButton();
		bindResponsiveMenuToggle();
		bindEventToggle();
		bindTitleToggle();
		bindTriggerClick();
		bindFocus();
		bindAvailableEventDateToggle();

		initializeDatePicker();
		initializeFancyBox();
		initializeCollapseScroll();

		initializeEventBookingForm();
        initializeImageCompareViewer();
	});

	$(function() {
		$('.no-js').remove();
	});

})(jQuery);


(function ($) {
	$(function () {
		function openAccordionIfContainsHash() {
			var hash = window.location.hash;
			if (hash) {
				var element = $(hash);
				if (element) {
					var collapse = $(hash).closest('.collapse');
					if (collapse) {
						collapse.collapse('show');
					}
				}
			}
		}

		$(window).on('hashchange', function() {
			openAccordionIfContainsHash();
		});
		setTimeout(function () {
			openAccordionIfContainsHash();
		}, 10);
	});
})(jQuery);


(function($) {
	$(function() {
		$('[data-clearable="true"]').each(function() {
			var that = $(this);

			var button = $('<div class="clearable-button"></div>');
			that.wrap('<div class="clearable-wrap"></div>').after(button);

			function toggle() {
				button.toggle(that.val() !== '');
			}

			that.on('input', toggle);
			button.on('click', function() {
				that.val('').focus();
				toggle();
			});

			toggle();
		});
	});
})(jQuery);

(function ($) {
	$(function () {
		$('[data-hash-change]').on('change', function () {
			window.location.hash = '#' + $(this).val();
        });
    });
})(jQuery);

(function ($) {
	$(function () {
		$('a.goback').on('click', function (e) {
			var _uri = document.location.href,
				_url = new URL(document.location.href);

			if (typeof _url !== 'undefined') {
				var _checkBack = _url.searchParams.get('back'),
					_href = $(this).data('back');

				if (_checkBack && _href) {
					document.location.href = _href;
					e.preventDefault();
				}
			}
        });
    });
})(jQuery);

function loadYoutubeIframe(id) {
    var preview = document.querySelector('[data-id=' + id + ']');
    var iframe = document.createElement('iframe');
    var size = preview.querySelector("img").getBoundingClientRect();

    iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', 'allowfullscreen');
    iframe.setAttribute('width', Math.round(size.width));
    iframe.setAttribute('height', Math.round(size.height));

    preview.parentNode.replaceChild(iframe, preview);
}

var ready = function () {

    if (document.body) {

        // implement focus-visible polyfill
        try {
            document.body.querySelector(':focus-visible');
        } catch (error) {
            var script = document.createElement('script');
            script.src = "/typo3conf/ext/theme/Resources/Public/Template/js/focus-visible.min.js";
            document.body.appendChild(script);
        }

        return;
    }

    window.requestAnimationFrame(ready);
};

window.requestAnimationFrame(ready);
